import { Injectable } from "@angular/core";
import { ApiService } from "./api.services";
import { BaseService } from "app/core/base.service";
import { Router } from "@angular/router";
import { HttpBackend, HttpClient, HttpHeaders } from "@angular/common/http";
import { LogTrustPrevRequest } from "../models/logTrustPrevRequest.model";
import { Observable } from "rxjs";
import { LogTrustPrev } from "../models/logTrustPrev.model";
import { environment } from "environments/environment";
import { AuthenticationService } from "./authentication.service";

@Injectable()
export class LogService {

    private strAction = 'api/LogTrustPrev';
    private httpClient: HttpClient;
    constructor(
        httpBackend: HttpBackend,
        private authenticationService: AuthenticationService) {
        this.httpClient = new HttpClient(httpBackend);
    }

    saveLog(request: LogTrustPrevRequest): Observable<LogTrustPrev> {
        const currentToken = this.authenticationService.currentTokenValue;

        if (currentToken) {
            const headers = new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${currentToken}`
            });
            return this.httpClient.post<LogTrustPrev>(`${environment.TrustCRMApiHost}${this.strAction}/Gravalog`, request, { headers });
        }
    }

    getAll(): Observable<LogTrustPrevRequest[]> {
        return;
    }

    deleteById(id: number) {
        return;
    }


}